import React, { useEffect, useState } from 'react';
import { Container, DateRangeWrapper, Wrapper, Row, DateInput, DateTitle, SaveButton } from './styled';
import DatePicker from 'react-datepicker';
import { pt } from 'date-fns/locale';
import Button from '../../ReUsableComponents/Button';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { datePreEntregaDatesUpdate } from '../../../../../Services/cardService';

const DataPreEntregaPopover = (props) => {
	const dispatch = useDispatch();
	const card = useSelector((state) => state.card);

	// Inicializa o estado da data de entrega
	const [datePreEntrega, setDatePreEntrega] = useState(
		card.datePreEntrega ? moment(card.datePreEntrega).toDate() : null
	);

	useEffect(() => {
		// Atualiza o estado quando o card.dateEntrega mudar
		if (card.datePreEntrega) {
			setDatePreEntrega(moment(card.datePreEntrega).toDate());
		}
	}, [card.datePreEntrega]);

	// Salva a data de entrega
	const handleSaveClick = async () => {
		props.closeCallback();
		await datePreEntregaDatesUpdate(
			card.cardId,
			card.listId,
			card.boardId,
			datePreEntrega ? moment(datePreEntrega).format('YYYY-MM-DD') : null,
			dispatch
		);
	};

	// Remove a data de entrega
	const handleRemoveClick = async () => {
		props.closeCallback();
		await datePreEntregaDatesUpdate(card.cardId, card.listId, card.boardId, null, dispatch);
	};

	return (
		<Container>
			<DateRangeWrapper>
				<DatePicker
					selected={datePreEntrega}
					onChange={(date) => setDatePreEntrega(date)}
					dateFormat="dd/MM/yyyy"
					locale={pt}
					placeholderText="Selecione uma data"
					inline
				/>
			</DateRangeWrapper>
			<Wrapper>
				<DateTitle>Data de Entrega</DateTitle>
				<Row>
					<DateInput
						value={datePreEntrega ? moment(datePreEntrega).format('DD/MM/YYYY') : ''}						
					/>
				</Row>
				<SaveButton onClick={handleSaveClick}>Salvar</SaveButton>
				<Button clickCallback={handleRemoveClick} title="Remover" />
			</Wrapper>
		</Container>
	);
};

export default DataPreEntregaPopover;
